window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

slate.Snippets = function Snippets() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this));
};

slate.Snippets.prototype = $.extend({}, slate.Snippets.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-snippet-id');
    var type = $container.attr('data-snippet-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-snippet-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-snippet-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();

slate.Modals = function Modals() {
  this.modals = {};

  $(document)
    .on('modal:show', this.onModalShow.bind(this))
    .on('modal:hide', this.onModalHide.bind(this))
    .on('modal:toggle', this.onModalToggle.bind(this))
    .on('keydown', this.onKeydown.bind(this));
};

slate.Modals.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(constructor) {
    return new constructor();
  },

  onModalShow: function(e, type) {
    if (this.modals[type]) {
      $(document.body).addClass('modal-active');
      this.modals[type]._onShow();
    }
  },

  onModalHide: function(e, type) {
    if (this.modals[type]) {
      $(document.body).removeClass('modal-active');
      this.modals[type]._onHide();
    }
  },

  onModalToggle: function(e, type) {
    if (this.modals[type]) {
      $(document.body).toggleClass('modal-active');
      this.modals[type]._onToggle();
    }
  },

  onKeydown: function(e) {
    if (e.key == 'Escape' || e.key == 'Esc' || e.keyCode == 27) {
      for (var type in this.modals) {
        if (this.modals[type].hideOnEsc) {
          this.modals[type].hide();
        }
      }
    }
  },

  register: function(type, constructor) {
    this.modals[type] = this._createInstance(constructor);
  }
});

slate.Tabs = (function() {

  var selectors = {
    tabs: '[role=tab]',
    tabPanels: '[role=tabpanel]'
  };

  /**
   * Tabs section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Tabs() {
    this.$tabs = $(selectors.tabs);
    this.$tabPanels = $(selectors.tabPanels);

    if (window.location.hash) {
      this.setActiveTab(window.location.hash);
    }

    this.$tabs.click(this.onTabClick.bind(this));
  }

  Tabs.prototype = $.extend({}, Tabs.prototype, {

    setActiveTab: function(hash) {
      var $tab = this.$tabs.filter('[href="' + hash + '"]');
      var $tabPanel = this.$tabPanels.filter(hash);

      $tab.siblings().removeClass('active');
      $tabPanel.siblings().removeClass('active');

      $tab.addClass('active');
      $tabPanel.addClass('active');
    },

    onTabClick: function(e) {
      window.location.hash = e.target.hash;
      this.setActiveTab(e.target.hash);

      e.preventDefault();
    }

  });

  return Tabs;

})();

slate.Dropdowns = (function() {

  var selectors = {
    dropdownToggles: '.dropdown-toggle',
    dropdownMenus: '.dropdown-menu'
  };

  /**
   * Dropdowns section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Dropdowns() {
    this.$dropdownToggles = $(selectors.dropdownToggles);
    this.$dropdownMenus = $(selectors.dropdownMenus);

    this.$dropdownToggles.on('touchend', this.onToggleTouchend.bind(this));
    this.$dropdownMenus.on('touchend', this.onMenuTouchend.bind(this));

    $(document)
      .on('click', this.hideActiveDropdown.bind(this))
      .on('touchend', this.hideActiveDropdown.bind(this));
  }

  Dropdowns.prototype = $.extend({}, Dropdowns.prototype, {

    onToggleTouchend: function(e) {
      var $dropdownToggle = $(e.currentTarget),
          $dropdown = $dropdownToggle.closest('.dropdown'),
          isActive = $dropdown.hasClass('active');

      this.hideActiveDropdown();

      $dropdown.toggleClass('active', !isActive);

      e.preventDefault();
      e.stopPropagation();
    },

    onMenuTouchend: function(e) {
      e.stopPropagation();
    },

    hideActiveDropdown: function() {
      var $activeDropdown = $('.dropdown.active');

      if ($activeDropdown.length > 0) {
        $activeDropdown.removeClass('active');
      }
    }

  });

  return Dropdowns;

})();

slate.Accordians = (function() {

  var selectors = {
    accordian: '.accordian',
    accordianToggle: '.accordian-toggle',
    accordianContent: '.accordian-content'
  };

  /**
   * Accordians section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Accordians() {
    this.$accordians = $(selectors.accordian);
    this.$accordianToggle = $(selectors.accordianToggle);
    this.$accordianContent = $(selectors.accordianContent);

    this.$accordianToggle.on('touchend', this.onToggleTouchend.bind(this));
    this.$accordianContent.on('touchend', this.onContentTouchend.bind(this));

    $(document)
      // .on('click', this.hideActiveAccordian.bind(this))
      .on('touchend', this.hideActiveAccordian.bind(this));

    this.calcHeight()
  }

  Accordians.prototype = $.extend({}, Accordians.prototype, {

    calcHeight: function() {
      this.$accordians.each(function() {
        var $accordian = $(this),
            $accordianToggle = $accordian.find(selectors.accordianToggle),
            $accordianContent = $accordian.find(selectors.accordianContent),
            toggleHeight = $accordianToggle.height(),
            contentHeight = $accordianContent.height();

        $accordian.data('toggle-height', toggleHeight);
        $accordian.data('content-height', contentHeight);
      });
    },

    onToggleTouchend: function(e) {
      var $accordianToggle = $(e.currentTarget),
          $accordian = $accordianToggle.closest('.accordian'),
          isActive = $accordian.hasClass('active'),
          toggleHeight = $accordian.data('toggle-height'),
          contentHeight = $accordian.data('content-height');

      this.hideActiveAccordian();

      $accordian.toggleClass('active', !isActive);
      $accordian.css('height', (isActive ? toggleHeight : toggleHeight + contentHeight));

      e.preventDefault();
      e.stopPropagation();
    },

    onContentTouchend: function(e) {
      e.stopPropagation();
    },

    hideActiveAccordian: function() {
      var $activeAccordian = $('.accordian.active');

      if ($activeAccordian.length > 0) {
        $activeAccordian.removeClass('active');
        $activeAccordian.css('height', $activeAccordian.data('toggle-height'));
      }
    }

  });

  return Accordians;

})();


/*================ Sections ================*/
/**
 * Header Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Header template.
 *
 * @namespace header
 */

theme.Header = (function() {

  var selectors = {
    navLinkSearch: '.nav-link-search',
    navLinkLogin: '.nav-link-login',
    navLinkCart: '.nav-link-cart',
    navLinkCartCount: '.nav-link-cart .count',
    navLinkMenu: '.nav-link-menu'
  };

  /**
   * Header section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    this.$container = $(container);
    this.$navLinkSearch = this.$container.find(selectors.navLinkSearch);
    this.$navLinkLogin = this.$container.find(selectors.navLinkLogin);
    this.$navLinkCart = this.$container.find(selectors.navLinkCart);
    this.$navLinkCartCount = this.$container.find(selectors.navLinkCartCount);
    this.$navLinkMenu = this.$container.find(selectors.navLinkMenu);

    this.$navLinkSearch.click(this.showSearch.bind(this));
    this.$navLinkLogin.click(this.showLogin.bind(this));
    this.$navLinkCart.click(this.showCart.bind(this));
    this.$navLinkMenu.click(this.showMenu.bind(this));

    $(document)
      .on('header:update-cart', this.updateCart.bind(this));

    window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });

    // check initial scroll
    this.onScroll();
  }

  Header.prototype = $.extend({}, Header.prototype, {

    onScroll: function(e) {
      var small = window.pageYOffset > 0;

      if (small != this._small) {
        this._small = small;
        this.$container.toggleClass('small', this._small);
      }
    },

    showSearch: function() {
      $(document).trigger('modal:show', theme.SearchModalType);
    },

    showLogin: function() {
      $(document).trigger('modal:show', theme.LoginModalType);
    },

    showCart: function() {
      $(document).trigger('modal:show', theme.CartModalType);
    },

    showMenu: function() {
      $(document).trigger('modal:show', theme.MenuModalType);
    },

    updateCart: function() {
      $.ajax({
        url: '/cart',
        data: {
          view: 'count'
        },
        dataType: 'html',
        success: function(html) {
          this.$navLinkCartCount.text(html.trim());
        }.bind(this)
      });
    }

  });

  return Header;

})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * HomeCarousel Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the HomeCarousel template.
 *
 * @namespace HomeCarousel
 */

theme.HomeCarousel = (function() {

    var selectors = {
      carouselItems: '.carousel-item',
      carouselBtns: '.carousel-btn'
    };

    /**
     * HomeCarousel section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function HomeCarousel(container) {
      this.$container = $(container);
      this.$carouselItems = this.$container.find(selectors.carouselItems);
      this.$carouselBtns = this.$container.find(selectors.carouselBtns);

      this.$carouselBtns.click(this.onCarouselBtnClick.bind(this));
      this.$carouselBtns.on('mouseenter', this.onCarouselBtnMouseEnter.bind(this));
      this.$carouselBtns.on('mouseleave', this.onCarouselBtnMouseLeave.bind(this));

      $(window).on('resize', this.onResize.bind(this));

      if (window.innerWidth >= 340) {
        this.startCarouselProgress();
      }
    }

    HomeCarousel.prototype = $.extend({}, HomeCarousel.prototype, {

      onCarouselBtnClick: function(e) {
        var $btn = $(e.currentTarget);

        this.setActiveItem($btn.index());
      },

      onCarouselBtnMouseEnter: function(e) {
        this._paused = true;

        if (this._progressTween) {
          this._progressTween.pause();
        }
      },

      onCarouselBtnMouseLeave: function(e) {
        this._paused = false;

        if (this._progressTween) {
          this._progressTween.resume();
        }
      },

      onResize: debounce(function(e) {
        this.resetCarousel();

        if (window.innerWidth >= 340) {
          this.startCarouselProgress();
        }
      }, 1000),

      resetCarousel: function() {
        var $activeItem = this.$carouselItems.filter('.active'),
            $activeBtn = this.$carouselBtns.filter('.active'),
            $firstItem = this.$carouselItems.first(),
            $firstBtn = this.$carouselBtns.first();

        $activeItem.removeClass('active');
        $activeBtn.removeClass('active');

        if (this._progressTween) {
          this._progressTween.kill();
        }

        if (this._animateTween) {
          this._animateTween.kill();
        }

        $firstItem.addClass('active');
        $firstBtn.addClass('active');

        TweenMax.set($firstItem[0], {
          opacity: 1,
          x: 0
        });
      },

      startCarouselProgress: function() {
        var $activeBtn = this.$carouselBtns.filter('.active'),
            $circle = $activeBtn.find('circle');

        if (this._progressTween) {
          this._progressTween.kill();
        }

        this._progressTween = TweenMax.fromTo($circle[0], 7, {
          strokeDashoffset: 157
        }, {
          strokeDashoffset: 0,
          ease: Linear.easeNone,
          paused: this._paused,
          onComplete: function() {
            if ($activeBtn.is(':last-child')) {
              this.setActiveItem(0);
            } else {
              this.setActiveItem($activeBtn.index() + 1);
            }
          }.bind(this)
        });
      },

      setActiveItem: function(nextIndex) {
        var activeIndex = this.$carouselItems.filter('.active').index();

        if (activeIndex == nextIndex) {
          return;
        }

        if (this._animateTween && this._animateTween.isActive()) {
          return;
        }

        this.animateOut(activeIndex, function() {
          this.animateIn(nextIndex, function() {
            this.startCarouselProgress();
          }.bind(this));
        }.bind(this));
      },

      animateIn: function(i, callback) {
        var $item = this.$carouselItems.eq(i),
            $btn = this.$carouselBtns.eq(i),
            $circle = $btn.find('circle');

        $circle.css('stroke-dashoffset', '');
        $item.addClass('active');
        $btn.addClass('active');

        this._animateTween = TweenMax.fromTo($item[0], .6, {
          opacity: 0,
          x: 20
        }, {
          opacity: 1,
          x: 0,
          ease: Strong.easeOut,
          onComplete: callback
        });
      },

      animateOut: function(i, callback) {
        var $item = this.$carouselItems.eq(i),
            $btn = this.$carouselBtns.eq(i);

        $btn.removeClass('active');

        this._animateTween = TweenMax.to($item[0], .6, {
          opacity: 0,
          x: -20,
          ease: Strong.easeIn,
          onComplete: function() {
            $item.removeClass('active');
            callback();
          }
        });
      }

    });

    return HomeCarousel;

  })();

/**
 * ProductDetail Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the ProductDetail template.
 *
   * @namespace ProductDetail
 */

theme.ProductDetail = (function() {

    var selectors = {
      previews: '.preview',
      btnZoomIn: '.btn-zoom-in',
      btnRotate: '.btn-rotate',
      inputQty: 'input[name=_quantity]',
      inputQtyTotal: 'input[name=quantity]',
      btnMinus: '.btn-minus',
      btnPlus: '.btn-plus',
      inputVariants: 'input[name=id]'
    };

    /**
     * ProductDetail section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function ProductDetail(container) {
      this.$container = $(container);
      this.$previews = this.$container.find(selectors.previews);
      this.$btnZoomIn = this.$container.find(selectors.btnZoomIn);
      this.$btnRotate = this.$container.find(selectors.btnRotate);
      this.$inputQty = this.$container.find(selectors.inputQty);
      this.$inputQtyTotal = this.$container.find(selectors.inputQtyTotal);
      this.$btnMinus = this.$container.find(selectors.btnMinus);
      this.$btnPlus = this.$container.find(selectors.btnPlus);
      this.$inputVariants = this.$container.find(selectors.inputVariants);

      this.$btnZoomIn.click(this.onBtnZoomInClick.bind(this));
      this.$btnRotate.click(this.onBtnRotateClick.bind(this));
      this.$btnMinus.click(this.onBtnMinusClick.bind(this));
      this.$btnPlus.click(this.onBtnPlusClick.bind(this));
      this.$inputVariants.change(this.onVariantChange.bind(this));
    }

    ProductDetail.prototype = $.extend({}, ProductDetail.prototype, {

      onBtnZoomInClick: function(e) {
        var _this = this;
        var $pswp = $('.pswp');
        var $activePreview = this.$previews.filter('.active');
        var $images = $activePreview.find('img');

        var items = $images.map(function() {
          var $image = $(this);

          return {
            msrc: $image.attr('src'),
            src: $image.data('master-src'),
            w: 1024,
            h: 1024 / $image.data('aspect-ratio')
          };
        });

        var options = {
          index: $images.filter('.active').index(),
          getThumbBoundsFn: function(index) {
            var offset = $activePreview.offset();
            var width = $activePreview.width();

            return {
              x: offset.left,
              y: offset.top,
              w: width
            };
          },
          history: false,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: false,
          arrowEl: false
        };

        var gallery = new PhotoSwipe($pswp[0], PhotoSwipeUI_Default, items, options);

        gallery.listen('afterChange', function() {
          let i = gallery.getCurrentIndex();

          $images.filter('.active').removeClass('active');
          $images.eq(i).addClass('active');
        })

        gallery.init();
      },

      onBtnRotateClick: function(e) {
        if (this._isRotating) {
          return;
        }

        this._isRotating = true;

        var _this = this;
        var $activePreview = this.$previews.filter('.active');
        var $images = $activePreview.find('img');
        var $activeImage = $images.filter('.active');
        var $nextImage = $activeImage.next();

        if (!$nextImage.length) {
          $nextImage = $images.first();
        }

        $activeImage.removeClass('active');
        $activeImage.addClass('leave');
        $nextImage.addClass('enter');

        setTimeout(function() {
          $activeImage.addClass('leave-to');
          $nextImage.addClass('enter-to');

          setTimeout(function() {
            $activeImage.removeClass('leave leave-to');
            $nextImage.removeClass('enter enter-to');
            $nextImage.addClass('active');
          }, 300);

          setTimeout(function() {
            _this._isRotating = false;
          }, 350);
        });
      },

      onBtnMinusClick: function(e) {
        let val = parseInt(this.$inputQty.val()) || 1;

        if (val > 1) {
          this.$inputQty.val(val - 1);
        } else {
          this.$inputQty.val(val);
        }

        this.updateQtyTotal();
      },

      onBtnPlusClick: function(e) {
        let val = parseInt(this.$inputQty.val()) || 1;

        this.$inputQty.val(val + 1);

        this.updateQtyTotal();
      },

      onVariantChange: function(e) {
        var variantId = $(e.target).val(),
            $activePreview = this.$previews.filter('.active'),
            $variantPreview = this.$previews.filter('[data-variant-id=' + variantId + ']');

        if ($variantPreview.length == 0) {
          $variantPreview = this.$previews.filter('[data-variant-id=-1]');
        }

        if (!$variantPreview.is($activePreview)) {
          $activePreview.removeClass('active');
          $variantPreview.addClass('active');
        }

        this.updateQtyTotal();
      },

      updateQtyTotal: function() {
        var $activeVariant = this.$inputVariants.filter(':checked'),
            qty = this.$inputQty.val(),
            qtyMultiplier = $activeVariant.data('qty-multiplier'),
            qtyTotal = qty * qtyMultiplier;

        this.$inputQtyTotal.val(qtyTotal);
      }

    });

    return ProductDetail;
  })();

/**
 * LoginForm Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the LoginForm template.
 *
 * @namespace LoginForm
 */

theme.LoginForm = (function() {

  var selectors = {
    formControls: '.form-control',
    login: '#login',
    loginForgot: '#login .forgot',
    recover: '#recover',
    recoverCancel: '#recover .cancel'
  };

  /**
   * LoginForm section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function LoginForm(container) {
    this.$container = $(container);
    this.$formControls = this.$container.find(selectors.formControls);
    this.$login = this.$container.find(selectors.login);
    this.$loginForgot = this.$container.find(selectors.loginForgot);
    this.$recover = this.$container.find(selectors.recover);
    this.$recoverCancel = this.$container.find(selectors.recoverCancel);

    this.$formControls.change(this.onFormControlChange.bind(this));
    this.$loginForgot.click(this.onLoginForgotClick.bind(this));
    this.$recoverCancel.click(this.onRecoverCancelClick.bind(this));
  }

  LoginForm.prototype = $.extend({}, LoginForm.prototype, {

    onFormControlChange: function(e) {
      var $formControl = $(e.target);
      var $formGroup = $formControl.closest('.form-group');

      $formGroup.removeClass('has-error');
    },

    onLoginForgotClick: function(e) {
      window.location.hash = e.target.hash;
      e.preventDefault();

      this.$login.removeClass('active');
      this.$recover.addClass('active');
    },

    onRecoverCancelClick: function(e) {
      window.location.hash = e.target.hash;
      e.preventDefault();

      this.$recover.removeClass('active');
      this.$login.addClass('active');
    }

  });

  return LoginForm;

})();

/**
 * SearchForm Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the SearchForm template.
 *
 * @namespace SearchForm
 */

theme.SearchForm = (function() {

    function getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split('=');
          if (decodeURIComponent(pair[0]) == variable) {
              return decodeURIComponent(pair[1]);
          }
      }
      return null;
    }

    var selectors = {
      form: 'form',
      search: 'input[type=search]'
    };

    /**
     * SearchForm section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function SearchForm(container) {
      var s = getQueryVariable('s');

      this.$container = $(container);
      this.$form = this.$container.find(selectors.form);
      this.$search = this.$container.find(selectors.search);

      this.$form.submit(this.onFormSubmit.bind(this));

      if (s) {
        this.initialSearch(s);
      }
    }

    SearchForm.prototype = $.extend({}, SearchForm.prototype, {

      initialSearch: function(s) {
        this._initialSearch = true;
        this.$search.val(s);
        this.$form.submit();
      },

      onFormSubmit: function(e) {
        e.preventDefault();
        this.fetchResults();
      },

      fetchResults: debounce(function() {
        var q = this.$search.val();

        if (q == this._lastQ) {
          return;
        }

        this._lastQ = q;

        if (q.length == 0) {
          if (history && history.pushState) {
            history.pushState({}, document.title, location.origin + location.pathname);
          }

          return $(document).trigger('search:clear-results');
        }

        if (!this._initialSearch) {
          if (history && history.pushState) {
            history.pushState({}, document.title, location.origin + location.pathname + '?s=' + q);
          }

          window.ga && window.ga('send', 'pageview', '?s=' + q);
        } else {
          this._initialSearch = false;
        }

        $.ajax({
          url: '/search',
          data: {
            q: q,
            type: 'article,product',
            view: 'partial'
          },
          dataType: 'html',
          success: function(html) {
            if (html.indexOf('<!-- no results -->') >= 0) {
              $(document).trigger('search:no-results', q);
            } else {
              $(document).trigger('search:results', html);
            }
          }
        });
      }, 1000)

    });

    return SearchForm;

  })();

/**
 * SearchResults Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the SearchResults template.
 *
 * @namespace SearchResults
 */

theme.SearchResults = (function() {

    var selectors = {
      results: '.results'
    };

    /**
     * SearchResults section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function SearchResults(container) {
      this.$container = $(container);
      this.$results = this.$container.find(selectors.results);

      $(document)
        .on('search:results', this.onSearchResults.bind(this))
        .on('search:no-results', this.onSearchNoResults.bind(this))
        .on('search:clear-results', this.onSearchClearResults.bind(this));
    }

    SearchResults.prototype = $.extend({}, SearchResults.prototype, {

      onSearchResults: function(e, html) {
        this.$container.show();
        this.$results.html(html);
      },

      onSearchNoResults: function(e) {
        this.$container.hide();
      },

      onSearchClearResults: function(e) {
        this.$container.show();
        this.$results.empty();
      }

    });

    return SearchResults;

  })();

/**
 * SearchNoResults Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the SearchNoResults template.
 *
 * @namespace SearchNoResults
 */

theme.SearchNoResults = (function() {

    var selectors = {
      q: '.q'
    };

    /**
     * SearchNoResults section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function SearchNoResults(container) {
      this.$container = $(container);
      this.$q = this.$container.find(selectors.q);

      $(document)
        .on('search:results', this.onSearchResults.bind(this))
        .on('search:no-results', this.onSearchNoResults.bind(this))
        .on('search:clear-results', this.onSearchClearResults.bind(this));
    }

    SearchNoResults.prototype = $.extend({}, SearchNoResults.prototype, {

      onSearchResults: function(e) {
        this.$container.hide();
      },

      onSearchNoResults: function(e, q) {
        this.$container.show();
        this.$q.text(q);
      },

      onSearchClearResults: function(e) {
        this.$container.hide();
      }

    });

    return SearchNoResults;

  })();

/**
 * ContactForm Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the ContactForm template.
 *
 * @namespace ContactForm
 */

theme.ContactForm = (function() {

  var selectors = {
    formControls: '.form-control'
  };

  /**
   * ContactForm section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function ContactForm(container) {
    this.$container = $(container);
    this.$formControls = this.$container.find(selectors.formControls);

    this.$formControls.change(this.onFormControlChange.bind(this));
  }

  ContactForm.prototype = $.extend({}, ContactForm.prototype, {

    onFormControlChange: function(e) {
      var $formControl = $(e.target);
      var $formGroup = $formControl.closest('.form-group');

      $formGroup.removeClass('has-error');
    }

  });

  return ContactForm;

})();

/**
 * StoreFinderForm Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the StoreFinderForm template.
 *
 * @namespace StoreFinderForm
 */

theme.StoreFinderForm = (function() {

  var selectors = {
    form: 'form',
    btnLocation: '.btn-location',
    searchLocation: 'input[type=search]',
    stores: 'input[name=stores]'
  };

  /**
   * StoreFinderForm section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function StoreFinderForm(container) {
    this.$container = $(container);
    this.$form = this.$container.find(selectors.form);
    this.$btnLocation = this.$container.find(selectors.btnLocation);
    this.$searchLocation = this.$container.find(selectors.searchLocation);
    this.$stores = this.$container.find(selectors.stores);

    this.autocomplete = null;

    this.$form.submit(this.onFormSubmit.bind(this));
    this.$btnLocation.click(this.onBtnLocationClick.bind(this));
    this.$stores.change(this.updateStores.bind(this));

    $(document)
      .on('google-maps:ready', this.initAutocomplete.bind(this));

    if (window.google) {
      this.initAutocomplete();
    }
  }

  StoreFinderForm.prototype = $.extend({}, StoreFinderForm.prototype, {

    initAutocomplete: function() {
      this.autocomplete = new google.maps.places.Autocomplete(this.$searchLocation[0], {
        types: ['(cities)'],
        componentRestrictions: {
          'country': 'au'
        }
      });

      this.autocomplete.addListener('place_changed', this.onPlaceChanged.bind(this));
    },

    onPlaceChanged: function() {
      var place = this.autocomplete.getPlace();

      if (place) {
        this.updateLocation(place.geometry.location.toJSON());
      }
    },

    onBtnLocationClick: function(e) {
      if ("geolocation" in navigator) {
        this.$btnLocation.attr('disabled', true);

        navigator.geolocation.getCurrentPosition(function(pos) {
          this.updateLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude
          });

          this.$btnLocation.attr('disabled', false);
        }.bind(this), function() {
          this.$btnLocation.attr('disabled', false);
        }.bind(this));
      }
    },

    onFormSubmit: function(e) {
      e.preventDefault();

      this.onPlaceChanged();
    },

    updateLocation: function(location) {
      $(document).trigger('store-finder:update-location', location);
    },

    updateStores: function() {
      var $selectedStores = this.$stores.filter(':checked');
      var stores = [];

      $selectedStores.each(function (i, el) {
        stores.push(el.value)
      });

      $(document).trigger('store-finder:update-stores', { stores: stores });
    }

  });

  return StoreFinderForm;

})();

/**
 * StoreFinderResults Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the StoreFinderResults template.
 *
 * @namespace StoreFinderResults
 */

theme.StoreFinderResults = (function() {

  var selectors = {
    map: '.map',
    results: '.results',
    resultTemplate: '#result_template'
  };

  function distance(lat1, lng1, lat2, lng2) {
    var p = 0.017453292519943295;    // Math.PI / 180
    var c = Math.cos;
    var a = 0.5 - c((lat2 - lat1) * p)/2 +
            c(lat1 * p) * c(lat2 * p) *
            (1 - c((lng2 - lng1) * p))/2;

    return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
  }

  function createAddressString(result) {
    let address = result['Address'] + '<br>';

    if (result['Address 2']) {
      address += result['Address 2'] + '<br>';
    }

    address += result['City'] + ', ';
    address += result['Province/State'] + ' ' + result['Postal/Zip Code'] + ', ';
    address += result['Country'];

    return address;
  }

  function markerCalculator(markers, numStyles) {
    var index = 0;
    var count = 0;
    for (var i = 0; i < markers.length; i++) {
      if (markers[i].getVisible()) {
        count++;
      }
    }
    var dv = count;
    while (dv !== 0) {
      dv = parseInt(dv / 10, 10);
      index++;
    }

    index = Math.min(index, numStyles);
    return {
      text: count,
      index: index
    };
  }

  /**
   * StoreFinderResults section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function StoreFinderResults(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.$results = this.$container.find(selectors.results);
    this.$resultTemplate = this.$container.find(selectors.resultTemplate);

    this.center = null;
    this.map = null;
    this.markerClusterer = null;
    this.results = [];
    this.config = {
      location: null,
      stores: null
    };

    $(document)
      .on('google-maps:ready', this.initMap.bind(this))
      .on('store-finder:update-location', this.updateLocation.bind(this))
      .on('store-finder:update-stores', this.updateStores.bind(this));

    if (window.google) {
      this.initMap();
    }
  }

  StoreFinderResults.prototype = $.extend({}, StoreFinderResults.prototype, {

    initMap: function() {
      this.center = new google.maps.LatLng(INIT_LATITUDE, INIT_LONGITUDE);

      this.map = new google.maps.Map(this.$map[0], {
        center: this.center,
        zoom: INIT_ZOOM
      });

      // this.map.addListener('center_changed', this.updateResults.bind(this));

      this.fetchStores();
    },

    fetchStores: function() {
      Papa.parse(STORES_URL, {
        download: true,
        header: true,
        complete: function(results) {
          this.results = results.data;
          this.initMarkers();
        }.bind(this)
      });
    },

    initMarkers: function() {
      var markerIcon = new google.maps.MarkerImage(MARKER_IMAGE, new google.maps.Size(32, 46));

      var markers = this.results.map(function(result) {
        // visible by default
        result.visible = true;

        result.marker = new google.maps.Marker({
          position: new google.maps.LatLng(result.Latitude, result.Longitude),
          title: result.Name,
          icon: markerIcon
        });

        // marker.addListener('click', this.onMarkerClick.bind(this));
        result.marker.addListener('click', function() {
          this.onResultClick(result);
        }.bind(this));

        return result.marker;
      }.bind(this));

      this.markerClusterer = new MarkerClusterer(this.map, markers, {
        gridSize: 40,
        styles: [{
          url: MARKER_CLUSTER_IMAGE,
          height: 32,
          width: 32,
          anchor: [0, 0],
          textColor: '#fff',
          textSize: 14
        }, {
          url: MARKER_CLUSTER_IMAGE,
          height: 32,
          width: 32,
          anchor: [0, 0],
          textColor: '#fff',
          textSize: 13
        }, {
          url: MARKER_CLUSTER_IMAGE,
          height: 32,
          width: 32,
          anchor: [0, 0],
          textColor: '#fff',
          textSize: 12
        }]
      });

      this.markerClusterer.setCalculator(markerCalculator);
    },

    onResultClick: function(result) {
      this.map.setCenter(result.marker.position);
      this.map.setZoom(17);

      this.$results.children().detach();

      if (!result.$el) {
        result.$el = this.createResultEl(result);
      }

      this.$results.append(result.$el);
    },

    updateLocation: function(e, location) {
      this.config.location = location;

      this.updateMap();
      this.updateDistances();
      this.updateResults();
    },

    updateStores: function(e, data) {
      this.config.stores = data.stores;

      this.updateVisibility();
      this.updateMarkers();
      this.updateResults();
    },

    updateMap: function() {
      if (!this.map || !this.config.location) {
        return;
      }

      var latlng = new google.maps.LatLng(this.config.location.lat, this.config.location.lng);

      if (!latlng.equals(this.map.getCenter())) {
        this.map.setCenter(latlng);
        this.map.setZoom(13);
      }
    },

    updateDistances: function() {
      if (!this.config.location) {
        return;
      }

      for (var i = 0; i < this.results.length; i++) {
        let result = this.results[i];
        result.distance = distance(parseFloat(result.Latitude), parseFloat(result.Longitude), this.config.location.lat, this.config.location.lng);
      }
    },

    updateVisibility: function() {
      for (var i = 0; i < this.results.length; i++) {
        var result = this.results[i],
            visible = true;

        if (this.config.stores && this.config.stores.indexOf(result['Store Group']) == -1) {
          visible = false;
        }

        result.visible = visible;
      }
    },

    updateMarkers: function() {
      var modified = false;

      for (var i = 0; i < this.results.length; i++) {
        var result = this.results[i];

        if (result.visible != result.marker.getVisible()) {
          modified = true;
          result.marker.setVisible(result.visible);
        }
      }

      if (modified) {
        this.markerClusterer.resetViewport();
        this.markerClusterer.redraw();
      }
    },

    updateResults: function() {
      this.$results.children().detach();

      let results = this.results.filter(function(result) {
        return result.visible && result.distance < 50;
      });

      results.sort(function(a, b) {
        return a.distance - b.distance;
      });

      results = results.slice(0, 20);

      for (var i = 0; i < results.length; i++) {
        var result = results[i];

        if (!result.$el) {
          result.$el = this.createResultEl(result)
        }

        result.$el.find('.distance').text(result.distance.toFixed(2) + ' km');
        result.$el.appendTo(this.$results);
      }
    },

    createResultEl: function(result) {
      var $el = this.$resultTemplate.clone();
      $el.attr('id', '');
      $el.find('.title').text(result.Name).click(function() {
        this.onResultClick(result);
      }.bind(this));
      $el.find('.address').html(createAddressString(result));
      $el.find('.navigation').attr('href', 'https://www.google.com/maps/dir/?api=1&destination=' + result.Latitude + ',' + result.Longitude);

      if (result.Phone) {
        $el.find('.phone').attr('href', 'tel:' + result.Phone);
        $el.find('.phone span').text(result.Phone);
      } else {
        $el.find('.phone').remove();
      }

      return $el;
    }

  });

  return StoreFinderResults;

})();

/**
 * FaqsContent Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the FaqsContent template.
 *
 * @namespace FaqsContent
 */

theme.FaqsContent = (function() {

    var selectors = {
      articles: '.article',
      articleHeadings: '.article h4'
    };

    /**
     * FaqsContent section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function FaqsContent(container) {
      this.$container = $(container);
      this.$articles = this.$container.find(selectors.articles);
      this.$articleHeadings = this.$container.find(selectors.articleHeadings);

      if (window.location.hash) {
        this.setActiveArticle(window.location.hash)
      }

      this.$articleHeadings.click(this.toggleArticle.bind(this));
    }

    FaqsContent.prototype = $.extend({}, FaqsContent.prototype, {

      setActiveArticle: function(hash) {
        var $article = this.$articles.filter(hash),
            $articleHeading = $article.find('h4'),
            $articleContent = $article.find('.content');

        $articleHeading.addClass('active');
        $articleContent.css('display', 'block');
      },

      toggleArticle: function(e) {
        var $heading = $(e.target),
            $content = $heading.next();

        $heading.toggleClass('active');
        $content.slideToggle({
          duration: 300
        });
      }

    });

    return FaqsContent;

  })();

/**
 * CartContent Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the CartContent template.
 *
 * @namespace CartContent
 */

theme.CartContent = (function() {

  var selectors = {
    qtyInputs: 'input[name=_quantity]',
    qtyInputTotals: 'input[name="updates[]"]',
    btnUp: '.btn-up',
    btnDown: '.btn-down',
    btnUpdate: '.btn[name=update]'
  };

  /**
   * CartContent section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function CartContent(container) {
    this.$container = $(container);
    this.$qtyInputs = this.$container.find(selectors.qtyInputs);
    this.$qtyInputTotals = this.$container.find(selectors.qtyInputTotals);
    this.$btnUp = this.$container.find(selectors.btnUp);
    this.$btnDown = this.$container.find(selectors.btnDown);
    this.$btnUpdate = this.$container.find(selectors.btnUpdate);

    this.$qtyInputs.change(this.onQtyInputChange.bind(this));
    this.$btnUp.click(this.onBtnUpClick.bind(this));
    this.$btnDown.click(this.onBtnDownClick.bind(this));
  }

  CartContent.prototype = $.extend({}, CartContent.prototype, {

    onQtyInputChange: function(e) {
      var $qtyInput = $(e.currentTarget),
          $qtyInputTotal = $qtyInput.siblings().filter(this.$qtyInputTotals),
          qty = $qtyInput.val(),
          qtyMultiplier = $qtyInputTotal.data('qty-multiplier'),
          qtyTotal = qty * qtyMultiplier;

      $qtyInputTotal.val(qtyTotal);
      this.$btnUpdate.show();
    },

    onBtnUpClick: function(e) {
      var $btnUp = $(e.currentTarget),
          $qtyInput = $btnUp.siblings().filter(this.$qtyInputs),
          qty = parseInt($qtyInput.val());

      if (isFinite(qty)) {
        $qtyInput.val(qty + 1);
        $qtyInput.triggerHandler('change');
      }
    },

    onBtnDownClick: function(e) {
      var $btnDown = $(e.currentTarget),
          $qtyInput = $btnDown.siblings().filter(this.$qtyInputs),
          qty = parseInt($qtyInput.val());

      if (isFinite(qty) && qty > 1) {
        $qtyInput.val(qty - 1);
        $qtyInput.triggerHandler('change');
      }
    }

  });

  return CartContent;

})();

/**
 * NoticeContent Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the NoticeContent template.
 *
 * @namespace NoticeContent
 */

theme.NoticeContent = (function() {

  var selectors = {
    form: 'form'
  };

  /**
   * NoticeContent section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function NoticeContent(container) {
    this.$body = $('body');
    this.$container = $(container);
    this.$form = this.$container.find(selectors.form);

    this.$form.submit(this.onFormSubmit.bind(this));

    if (!this.hasAgreed() && this.isParticularPage()) {
      setTimeout(function() {
        $(document).trigger('modal:show', 'notice');
      }, 1000);
    }
  }

  NoticeContent.prototype = $.extend({}, NoticeContent.prototype, {

    hasAgreed: function() {
      return !!sessionStorage.getItem('tcs_agree')
    },

    /**
     * True for collection, pages, products which has show-notice-modal class
     * This class is manage from the Custom Fields App
     */
    isParticularPage: function() {
      return this.$body.hasClass('show-notice-modal') ? true : false;
    },

    onFormSubmit: function(e) {
      e.preventDefault();
      sessionStorage.setItem('tcs_agree', 'yes');
      $(document).trigger('modal:hide', 'notice');
    }

  });

  return NoticeContent;

})();

/**
 * AddressesDetail Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the AddressesDetail template.
 *
 * @namespace addressesDetail
 */

theme.AddressesDetail = (function() {

  var selectors = {
    editAddress: '.edit-address',
    newAddress: '.new-address'
  };

  /**
   * AddressesDetail section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function AddressesDetail(container) {
    this.$container = $(container);
    this.$editAddress = this.$container.find(selectors.editAddress);
    this.$newAddress = this.$container.find(selectors.newAddress);

    this.$editAddress.click(this.onClickEdit.bind(this));
    this.$newAddress.click(this.onClickNew.bind(this));
  }

  AddressesDetail.prototype = $.extend({}, AddressesDetail.prototype, {

    onClickEdit: function(e) {
      var id = $(e.target).data('address-id');

      $(document).trigger('address-modal:select', id);
      $(document).trigger('modal:show', theme.AddressModalType);

      e.preventDefault();
    },

    onClickNew: function() {
      $(document).trigger('modal:show', theme.AddressNewModalType);
    }

  });

  return AddressesDetail;

})();

/*================ Snippets ================*/
/**
 * ProductSnippet Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the ProductSnippet template.
 *
 * @namespace ProductSnippet
 */

theme.ProductSnippet = (function() {

    var selectors = {
      form: 'form',
      btnSubmit: '.btn[type=submit]'
    };

    /**
     * ProductSnippet section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function ProductSnippet(container) {
      this.$container = $(container);
      this.$form = this.$container.find(selectors.form);
      this.$btnSubmit = this.$container.find(selectors.btnSubmit);

      this.$form.submit(this.onFormSubmit.bind(this));
    }

    ProductSnippet.prototype = $.extend({}, ProductSnippet.prototype, {

      onFormSubmit: function(e) {
        e.preventDefault();

        this.$btnSubmit.attr('disabled', true);

        $.post({
          url: '/cart/add.js',
          data: this.$form.serialize(),
          dataType: 'json',
          success: function() {
            $(document)
              .trigger('header:update-cart')
              .trigger('modal-cart:update');

            this.$btnSubmit.addClass('success');
            setTimeout(function() {
              this.$btnSubmit.removeClass('success');
            }.bind(this), 1500);
          }.bind(this),
          complete: function() {
            this.$btnSubmit.attr('disabled', false);
          }.bind(this)
        });
      }

    });

    return ProductSnippet;
  })();

/**
 * AddressSnippet Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the AddressSnippet template.
 *
 * @namespace AddressSnippet
 */

theme.AddressSnippet = (function() {

    var selectors = {
      form: 'form',
      countryField: '[name*=country]',
      provinceField: '[name*=province]'
    };

    /**
     * AddressSnippet section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function AddressSnippet(container) {
      this.$container = $(container);
      this.$form = this.$container.find(selectors.form);
      this.$countryField = this.$container.find(selectors.countryField);
      this.$provinceField = this.$container.find(selectors.provinceField);

      this.initCountryProvinceSelector();
    }

    AddressSnippet.prototype = $.extend({}, AddressSnippet.prototype, {

      initCountryProvinceSelector: function() {
        var country = this.$countryField.attr('id'),
            province = this.$provinceField.attr('id'),
            provinceContainer = this.$provinceField.attr('id') + '_container';

        new Shopify.CountryProvinceSelector(country, province, {
          hideElement: provinceContainer
        });
      }

    });

    return AddressSnippet;
  })();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Modals ================*/
/**
 * CartModal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the CartModal template.
 *
 * @namespace CartModal
 */

theme.CartModalType = 'cart';

theme.CartModal = (function() {
  var selectors = {
    modal: '.modal-cart',
    modalContent: '.modal-content',
    btnClose: '.btn-close'
  };

  function CartModal() {
    this.$modal = $(selectors.modal);
    this.$modalContent = this.$modal.find(selectors.modalContent);
    this.$btnClose = this.$modal.find(selectors.btnClose);

    this.$btnClose.click(this.hide.bind(this));

    $(document)
      .on('modal-cart:update', this.update.bind(this));
  }

  CartModal.prototype = $.extend({}, CartModal.prototype, {

    hideOnEsc: true,

    _onShow: function() {
      this.$modal.addClass('active');
    },

    _onHide: function() {
      this.$modal.removeClass('active');
    },

    _onToggle: function() {
      this.$modal.toggleClass('active');
    },

    show: function() {
      if (!this.$modal.hasClass('active')) {
        $(document).trigger('modal:show', theme.CartModalType);
      }
    },

    hide: function() {
      if (this.$modal.hasClass('active')) {
        $(document).trigger('modal:hide', theme.CartModalType);
      }
    },

    toggle: function() {
      $(document).trigger('modal:toggle', theme.CartModalType);
    },

    update: function() {
      $.ajax({
        url: '/cart',
        data: {
          view: 'partial'
        },
        dataType: 'html',
        success: function(html) {
          this.$modalContent.html(html);
          this.$modal.trigger('shopify:section:load');
          addCustomNotes();
        }.bind(this)
      });
    }

  });

  return CartModal;

})();

/**
 * SearchModal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the SearchModal template.
 *
 * @namespace SearchModal
 */

theme.SearchModalType = 'search';

theme.SearchModal = (function() {

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
  }

  var selectors = {
    modal: '.modal-search',
    btnClose: '.btn-close',
    search: 'input[type=search]'
  };

  function SearchModal() {
    this.$modal = $(selectors.modal);
    this.$btnClose = this.$modal.find(selectors.btnClose);
    this.$search = this.$modal.find(selectors.search);

    this.$btnClose.click(this.hide.bind(this));

    if (getQueryVariable('s')) {
      //setTimeout(() => this.show())
    }
  }

  SearchModal.prototype = $.extend({}, SearchModal.prototype, {

    hideOnEsc: true,

    _onShow: function() {
      this.$modal.addClass('active');
      this.$search.focus();
    },

    _onHide: function() {
      this.$modal.removeClass('active');
    },

    _onToggle: function() {
      this.$modal.toggleClass('active');
    },

    show: function() {
      if (!this.$modal.hasClass('active')) {
        $(document).trigger('modal:show', theme.SearchModalType);
      }
    },

    hide: function() {
      if (this.$modal.hasClass('active')) {
        $(document).trigger('modal:hide', theme.SearchModalType);
      }
    },

    toggle: function() {
      $(document).trigger('modal:toggle', theme.SearchModalType);
    }

  });

  return SearchModal;

})();

/**
 * LoginModal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the LoginModal template.
 *
 * @namespace LoginModal
 */

theme.LoginModalType = 'login';

theme.LoginModal = (function() {
  var selectors = {
    modal: '.modal-login',
    btnClose: '.btn-close',
    loginEmail: '#login_email'
  };

  function LoginModal() {
    this.$modal = $(selectors.modal);
    this.$btnClose = this.$modal.find(selectors.btnClose);
    this.$loginEmail = this.$modal.find(selectors.loginEmail);

    this.$btnClose.click(this.hide.bind(this));
  }

  LoginModal.prototype = $.extend({}, LoginModal.prototype, {

    hideOnEsc: true,

    _onShow: function() {
      this.$modal.addClass('active');
      this.$loginEmail.focus();
    },

    _onHide: function() {
      this.$modal.removeClass('active');
    },

    _onToggle: function() {
      this.$modal.toggleClass('active');
    },

    show: function() {
      if (!this.$modal.hasClass('active')) {
        $(document).trigger('modal:show', theme.LoginModalType);
      }
    },

    hide: function() {
      if (this.$modal.hasClass('active')) {
        $(document).trigger('modal:hide', theme.LoginModalType);
      }
    },

    toggle: function() {
      $(document).trigger('modal:toggle', theme.LoginModalType);
    }

  });

  return LoginModal;

})();

/**
 * NoticeModal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the NoticeModal template.
 *
 * @namespace NoticeModal
 */

theme.NoticeModalType = 'notice';

theme.NoticeModal = (function() {
  var selectors = {
    modal: '.modal-notice'
  };

  function NoticeModal() {
    this.$modal = $(selectors.modal);
  }

  NoticeModal.prototype = $.extend({}, NoticeModal.prototype, {

    _onShow: function() {
      if( customGetCookie('notice-popup') == 'yes' )
      {
        //console.log('don show');
        // don't show pop up
        $(document.body).removeClass('modal-active');
      }
      else {
        //console.log('show');
        this.$modal.addClass('active');
      }
    },

    _onHide: function() {
      this.$modal.removeClass('active');
    },

    _onToggle: function() {
      this.$modal.toggleClass('active');
    },

    show: function() {
      if (!this.$modal.hasClass('active')) {
        $(document).trigger('modal:show', theme.NoticeModalType);
      }
    },

    hide: function() {
      if (this.$modal.hasClass('active')) {
        $(document).trigger('modal:hide', theme.NoticeModalType);
      }
    },

    toggle: function() {
      $(document).trigger('modal:toggle', theme.NoticeModalType);
    }

  });

  return NoticeModal;

})();

/**
 * WechatModal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the WechatModal template.
 *
 * @namespace WechatModal
 */

theme.WechatModalType = 'wechat';

theme.WechatModal = (function() {
  var selectors = {
    modal: '.modal-wechat',
    btnClose: '.btn-close',
    anchors: '[href="#wechat"]'
  };

  function WechatModal() {
    this.$modal = $(selectors.modal);
    this.$btnClose = this.$modal.find(selectors.btnClose);
    this.$anchors = $(selectors.anchors);

    this.$btnClose.click(this.hide.bind(this));
    this.$anchors.click(this.onAnchorClick.bind(this));
  }

  WechatModal.prototype = $.extend({}, WechatModal.prototype, {

    hideOnEsc: true,

    onAnchorClick: function(e) {
      e.preventDefault();
      this.show();
    },

    _onShow: function() {
      this.$modal.addClass('active');
    },

    _onHide: function() {
      this.$modal.removeClass('active');
    },

    _onToggle: function() {
      this.$modal.toggleClass('active');
    },

    show: function() {
      if (!this.$modal.hasClass('active')) {
        $(document).trigger('modal:show', theme.WechatModalType);
      }
    },

    hide: function() {
      if (this.$modal.hasClass('active')) {
        $(document).trigger('modal:hide', theme.WechatModalType);
      }
    },

    toggle: function() {
      $(document).trigger('modal:toggle', theme.WechatModalType);
    }

  });

  return WechatModal;

})();

/**
 * AddressModal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the AddressModal template.
 *
 * @namespace AddressModal
 */

theme.AddressModalType = 'address';

theme.AddressModal = (function() {
  var selectors = {
    modal: '.modal-address',
    btnClose: '.btn-close'
  };

  function AddressModal() {
    this.$modal = $(selectors.modal);
    this.$btnClose = this.$modal.find(selectors.btnClose);

    this.$btnClose.click(this.hide.bind(this));

    $(document)
      .on('address-modal:select', this.onSelectAddress.bind(this));
  }

  AddressModal.prototype = $.extend({}, AddressModal.prototype, {

    hideOnEsc: true,

    onSelectAddress: function(e, id) {
      let $content = this.$modal.find('[data-address-id=' + id + ']');

      $content.siblings('.active').removeClass('active');
      $content.addClass('active');
    },

    _onShow: function() {
      this.$modal.addClass('active');
    },

    _onHide: function() {
      this.$modal.removeClass('active');
    },

    _onToggle: function() {
      this.$modal.toggleClass('active');
    },

    show: function() {
      if (!this.$modal.hasClass('active')) {
        $(document).trigger('modal:show', theme.AddressModalType);
      }
    },

    hide: function() {
      if (this.$modal.hasClass('active')) {
        $(document).trigger('modal:hide', theme.AddressModalType);
      }
    },

    toggle: function() {
      $(document).trigger('modal:toggle', theme.AddressModalType);
    }

  });

  return AddressModal;

})();

/**
 * AddressNewModal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the AddressNewModal template.
 *
 * @namespace AddressNewModal
 */

theme.AddressNewModalType = 'address-new';

theme.AddressNewModal = (function() {
  var selectors = {
    modal: '.modal-address-new',
    btnClose: '.btn-close'
  };

  function AddressNewModal() {
    this.$modal = $(selectors.modal);
    this.$btnClose = this.$modal.find(selectors.btnClose);

    this.$btnClose.click(this.hide.bind(this));
  }

  AddressNewModal.prototype = $.extend({}, AddressNewModal.prototype, {

    hideOnEsc: true,

    _onShow: function() {
      this.$modal.addClass('active');
    },

    _onHide: function() {
      this.$modal.removeClass('active');
    },

    _onToggle: function() {
      this.$modal.toggleClass('active');
    },

    show: function() {
      if (!this.$modal.hasClass('active')) {
        $(document).trigger('modal:show', theme.AddressNewModalType);
      }
    },

    hide: function() {
      if (this.$modal.hasClass('active')) {
        $(document).trigger('modal:hide', theme.AddressNewModalType);
      }
    },

    toggle: function() {
      $(document).trigger('modal:toggle', theme.AddressNewModalType);
    }

  });

  return AddressNewModal;

})();

/**
 * MenuModal Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the MenuModal template.
 *
 * @namespace MenuModal
 */

theme.MenuModalType = 'menu';

theme.MenuModal = (function() {
  var selectors = {
    modal: '.modal-menu',
    btnClose: '.btn-close',
    btnLogin: '.btn-login',
  };

  function MenuModal() {
    this.$modal = $(selectors.modal);
    this.$btnClose = this.$modal.find(selectors.btnClose);
    this.$btnLogin = this.$modal.find(selectors.btnLogin);

    this.$btnClose.click(this.hide.bind(this));
    this.$btnLogin.click(this.showLogin.bind(this));
  }

  MenuModal.prototype = $.extend({}, MenuModal.prototype, {

    hideOnEsc: true,

    _onShow: function() {
      this.$modal.addClass('active');
    },

    _onHide: function() {
      this.$modal.removeClass('active');
    },

    _onToggle: function() {
      this.$modal.toggleClass('active');
    },

    show: function() {
      if (!this.$modal.hasClass('active')) {
        $(document).trigger('modal:show', theme.MenuModalType);
      }
    },

    hide: function() {
      if (this.$modal.hasClass('active')) {
        $(document).trigger('modal:hide', theme.MenuModalType);
      }
    },

    toggle: function() {
      $(document).trigger('modal:toggle', theme.MenuModalType);
    },

    showLogin: function() {
      $(document).trigger('modal:hide', theme.MenuModalType);
      $(document).trigger('modal:show', theme.LoginModalType);
    }

  });

  return MenuModal;

})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('header', theme.Header);
  sections.register('product', theme.Product);
  sections.register('home-carousel-full-width', theme.HomeCarousel);
  sections.register('product-detail', theme.ProductDetail);
  sections.register('login-form', theme.LoginForm);
  sections.register('search-form', theme.SearchForm);
  sections.register('search-results', theme.SearchResults);
  sections.register('search-no-results', theme.SearchNoResults);
  sections.register('contact-form', theme.ContactForm);
  sections.register('store-finder-form', theme.StoreFinderForm);
  sections.register('store-finder-results', theme.StoreFinderResults);
  sections.register('faqs-content', theme.FaqsContent);
  sections.register('cart-content', theme.CartContent);
  sections.register('notice-content', theme.NoticeContent);
  sections.register('addresses-detail', theme.AddressesDetail);
  sections.register('blog-articles', theme.BlogArticles);

  var snippets = new slate.Snippets();
  snippets.register('product', theme.ProductSnippet);
  snippets.register('address', theme.AddressSnippet);

  var modals = new slate.Modals();
  modals.register(theme.CartModalType, theme.CartModal);
  modals.register(theme.SearchModalType, theme.SearchModal);
  modals.register(theme.LoginModalType, theme.LoginModal);
  modals.register(theme.NoticeModalType, theme.NoticeModal);
  modals.register(theme.WechatModalType, theme.WechatModal);
  modals.register(theme.AddressModalType, theme.AddressModal);
  modals.register(theme.AddressNewModalType, theme.AddressNewModal);
  modals.register(theme.MenuModalType, theme.MenuModal);

  var tabs = new slate.Tabs();
  var dropdowns = new slate.Dropdowns();
  var accordians = new slate.Accordians();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});


$(document).ready(function() {
  var noteUpdater = {
    init: function(el){
      
      /*
      //Event
      this.$phone = $(el).find('.cart-phone').on('keyup touchend', $.proxy(this, 'prependToNote'));
      this.$cartNotePlacement = $(el).find('.cart-note-placement').on('keyup touchend', $.proxy(this, 'appendToNote'));
      this.$cartNote = $(el).find('.cart-note');

      //Get Value
      this.cartPhoneEntry = this.$phone.val();
      this.cartNotePlacementEntry = this.$cartNotePlacement.val();

      //Set Value
      this.setNoteValue();
      */
    },

    prependToNote: function(event){
      var self = $(event.currentTarget);
      this.cartPhoneEntry = self.val();
      this.setNoteValue();
    },

    appendToNote: function(event){
      var self = $(event.currentTarget);
      this.cartNotePlacementEntry = self.val();
      this.setNoteValue();
    },

    setNoteValue: function() {
      this.$cartNote.val("Phone: " + this.cartPhoneEntry + "\n" + "Instruction: " + this.cartNotePlacementEntry );
    }
  }

  if ($(".cart-content").length){
    noteUpdater.init('.cart-content');
    addCustomNotes();
  }
});


// Hide quantify product and updaet button text on /caprilac-fresh-goat-milk-1l page
 $(document).ready(function() {

  if (window.location.href.indexOf("caprilac-fresh-goat-milk-1l") > -1) {
    $(".content .btn-custom").html('IN-STORE ONLY');
    $(".content .product-quantity").hide();
  }

  if ($(".caprilac-fresh-goat-milk-1l.snippet-product").length) {
    $(".caprilac-fresh-goat-milk-1l.snippet-product .btn").html('IN-STORE ONLY');
  }

  // Only show acnnoucment bar in a new session BUBS-101
  var displayAbar = {
    init: function(){
      this.$qabContainer = $("#qab_container");

      if (this.$qabContainer.length) {
        if (!this.hasClosed()) {
          this.$qabContainer.addClass('active');
          this.$btnClose = this.$qabContainer.find("#qab_close").on('click', $.proxy(this, 'setStorage'));
          this.$btnQab = this.$qabContainer.find("#qab_button").on('click', $.proxy(this, 'setStorage'));
        }
      }
    },

    hasClosed: function (){
      return !!sessionStorage.getItem('has_closed')
    },

    setStorage: function (){
      sessionStorage.setItem('has_closed', 'yes');
    },

    initTimeOut: function(){
      var _this = this;
      setTimeout( function(){
        _this.init();
      },3000);
    }
  }

  displayAbar.initTimeOut();
  
   jQuery('.modal.modal-notice form button.btn-submit').on('click', function() {
     customSetCookie('notice-popup',1);
   });
   
   jQuery('button.redmart-btn').on('click', function(e) {
     //e.preventDefault();
     //shopUrl = jQuery(this).data('redmart');
     //window.location.href = shopUrl;
   });

});

function customSetCookie(cname,days) {
  
   	date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    expires = "; expires="+date.toGMTString();
    var expiryDate = new Date();
    document.cookie = cname+"=yes; expires="+date.toGMTString()+"; path=/";
}

function customGetCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function addCustomNotes() {
  
  jQuery('.cart-content').find('form').on('submit',function(ev) {
        
        jQuery(".cart-content").find('.cart-note').val("Phone: " + jQuery(this).find('.cart-phone').val() + "\n" + "Instruction: " + jQuery(this).find('.cart-note-placement').val() );
        console.log(jQuery(".cart-content").find('.cart-note').val());
        //this.setNoteValue();
        //console.log(jQuery(this).serialize());
    });
}
